import React from 'react';
import ReactMarkdown from 'react-markdown';
import changelogMarkdown from '../content/changelogMarkdown';

export function stripEmptyUnreleasedSection(markdown: string): string {
    return markdown.replace(/^## Unreleased\s*\r?\n_No unreleased changes\._\s*(?:\r?\n)?/u, '').trimStart();
}

const Changelog: React.FC = () => {
    return (
        <div className="changelog-markdown">
            <ReactMarkdown>{stripEmptyUnreleasedSection(changelogMarkdown)}</ReactMarkdown>
        </div>
    );
};

export default Changelog;
